var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiCoach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76879 2.91971C7.95166 0.0267634 12.0484 0.0267625 13.2313 2.91971L14.6985 6.50811C14.8693 6.92593 15.0961 7.31865 15.3725 7.67551L17.7465 10.7404C19.6604 13.2112 17.6121 16.7591 14.5153 16.337L10.674 15.8135C10.2268 15.7525 9.77329 15.7525 9.32602 15.8135L5.48477 16.337C2.38796 16.7591 0.339604 13.2112 2.25353 10.7404L4.62756 7.67551C4.90399 7.31865 5.13072 6.92593 5.30156 6.50811L6.76879 2.91971Z",
    stroke: "#2BB9F8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2313 17.0797C12.0484 19.9727 7.95166 19.9727 6.76879 17.0797L5.30156 13.4913C5.13072 13.0735 4.90399 12.6808 4.62756 12.3239L2.25353 9.25908C0.339604 6.78821 2.38796 3.24035 5.48477 3.66243L9.32602 4.18597C9.77329 4.24693 10.2268 4.24693 10.674 4.18597L14.5153 3.66243C17.6121 3.24035 19.6604 6.78821 17.7465 9.25909L15.3725 12.3239C15.0961 12.6808 14.8693 13.0735 14.6985 13.4913L13.2313 17.0797Z",
    stroke: "#2BB9F8",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99992,
    cy: 10.0002,
    r: 1.16667,
    fill: "#2BB9F8",
    stroke: "#2BB9F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCoach);
export default __webpack_public_path__ + "static/media/ai_coach.0990fd3199ae8428467efe9ba30dac74.svg";
export { ForwardRef as ReactComponent };